"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrometheusEditorContainer = void 0;
var React = require("react");
var TagHelpers_1 = require("../Tag/TagHelpers");
var Utils_1 = require("../util/Utils");
var ConnectToDataSubspace_1 = require("./ConnectToDataSubspace");
var DefineObjectiveSubspace_1 = require("./DefineObjectiveSubspace");
var DeployModelSubspace_1 = require("./DeployModelSubspace");
var ModelResultSubspace_1 = require("./ModelResultSubspace");
var PrometheusEditorHeader_1 = require("./PrometheusEditorHeader");
var TrainModelSubspace_1 = require("./TrainModelSubspace");
var PrometheusEditorContainer = function (props) {
    var _a = React.useState(props.subspace), subspace = _a[0], setSubspace = _a[1];
    var _b = React.useState(''), content = _b[0], setContent = _b[1];
    var _c = React.useState(props.modelStatus), modelStatus = _c[0], setModelStatus = _c[1];
    var _d = React.useState({ storyId: '', runId: '' }), predictiveModelContent = _d[0], setPredictiveModelContent = _d[1];
    var _e = React.useState(''), modelResult = _e[0], setModelResult = _e[1];
    var _f = React.useState({
        dataSourceId: '',
        dataSourceVersionId: '',
        outcomeField: '',
        goal: '',
        algorithm: '',
        outcomeType: '',
        successValue: '',
        failureValue: '',
    }), objective = _f[0], setObjective = _f[1];
    var selectSubspace = function (selection) {
        setSubspace(selection);
    };
    var sayHello = function (favouriteThing) {
        TagHelpers_1.SayHello({ favouriteThing: favouriteThing }).then(function (response) {
            setContent(response.reply !== undefined ? response.reply : '');
        }, function (reason) {
            console.log(reason);
        });
    };
    var getComponentContent = function (subspace) {
        if (content !== '') {
            return ['Received response from service', content];
        }
        switch (subspace) {
            case Utils_1.SubspaceType.Connect:
                return ['Connnect title', 'Connect content'];
            case Utils_1.SubspaceType.Define:
                return ['Data Source A'];
            case Utils_1.SubspaceType.Train:
                return ['Train title', 'Train content'];
            case Utils_1.SubspaceType.Results:
                return ['Results title', 'Results content'];
            case Utils_1.SubspaceType.Deploy:
                return ['Model Deployment Status', 'Deployment Status'];
            default:
                return ['Connnect title', 'Connect content'];
        }
    };
    var outcomeTypeToModelType = function (outcome) {
        switch (outcome) {
            case 'Number':
                return Utils_1.ModelType.Regression;
            case 'Text':
                return Utils_1.ModelType.Binary;
            default:
                return Utils_1.ModelType.Undefined;
        }
    };
    var getSubspaceComponent = function (subspace) {
        var content = getComponentContent(subspace);
        switch (subspace) {
            case Utils_1.SubspaceType.Connect:
                return React.createElement(ConnectToDataSubspace_1.ConnectToDataSubspace, { modelStatus: modelStatus, subspaceTitle: content[0], subspaceContent: content[1], greet: sayHello });
            case Utils_1.SubspaceType.Define:
                return (React.createElement(DefineObjectiveSubspace_1.DefineObjectiveSubspace, { setModelStatus: setModelStatus, setObjective: setObjective, objective: objective, setSubspace: selectSubspace, datasourceName: content[0] }));
            case Utils_1.SubspaceType.Train:
                return (React.createElement(TrainModelSubspace_1.TrainModelSubspace, { predictiveModelContent: predictiveModelContent, setPredictiveModelContent: setPredictiveModelContent, setModelStatus: setModelStatus, setSubspace: selectSubspace, setModelResult: setModelResult, objective: objective }));
            case Utils_1.SubspaceType.Results:
                return React.createElement(ModelResultSubspace_1.ModelResultSubspace, { modelType: outcomeTypeToModelType(objective.outcomeType), modelResult: modelResult });
            case Utils_1.SubspaceType.Deploy:
                return (React.createElement(DeployModelSubspace_1.DeployModelSubspace, { subspaceTitle: content[0], subspaceContent: content[1], predictiveModelContent: predictiveModelContent }));
            default:
                return React.createElement(ConnectToDataSubspace_1.ConnectToDataSubspace, { modelStatus: modelStatus, subspaceTitle: content[0], subspaceContent: content[1], greet: sayHello });
        }
    };
    return (React.createElement("div", { style: {
            width: '100%',
            height: '100%',
        } },
        React.createElement("div", null,
            React.createElement(PrometheusEditorHeader_1.PrometheusEditorHeader, { selectSubspace: selectSubspace, connectSubtitle: 'Spotify', defineSubtitle: undefined, trainSubtitle: undefined, resultsSubtitle: undefined, deploySubtitle: undefined, modelStatus: modelStatus }),
            React.createElement("div", { style: {
                    width: '100%',
                    borderTopWidth: 2,
                    borderTopStyle: 'solid',
                    borderTopColor: '#605C5C',
                    height: 0,
                } })),
        React.createElement("div", { style: {
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f2f2f2',
            } }, getSubspaceComponent(subspace))));
};
exports.PrometheusEditorContainer = PrometheusEditorContainer;
//# sourceMappingURL=PrometheusEditorContainer.js.map